import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _HealthContract, _HealthScope, _MeansAdministration, _PharmaCumState, _PharmaRecordState } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthID } from "../../../../admin/configuracion/HealthID/HealthID";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { HealthContractTypeEditor } from "../HealthContractType/HealthContractTypeEditor";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../../theme/Input/InputDate";


export const HealthContract = () => {

    const contract = useDataBean(_HealthContract);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setForm] = useState<any>({
        HealthContractTypeName:null,
        IDHealthContractType:null
    })
    const [Account, setAccount] = useState<number>(null)
    const [date, setdate] = useState<number>(null)
    const [Enabled, setEnabled] = useState<any>(null)
    const [modalsoporte, setModalsoporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        contract.instance.getHealthContractCatalog(form.IDHealthContractType,Account,regexStr,date,Enabled, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        contract.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        contract.instance.deleteVoid(contract.bean.IDHealthScope).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        contract.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthContract', visible: true },
        { title: 'Tipo de Contrato', property: 'Type', visible: true },
        { title: 'Beneficiario Contrato', property: 'AccountName', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Objeto', property: 'Description', visible: true },
         { title: 'Fecha Inicio', property: 'InitDate', visible: true },
          { title: 'Fecha Hasta', property: 'UptoDate', visible: true },
           { title: 'Habilitado', property: 'Enabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Soportes de Pago', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalsoporte({ ...modalsoporte, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <BasicPage titulo="Contratos de Servicios y/o Tecnologías en Salud">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor label="Tercero" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-4">
                     <HealthContractTypeEditor render={form.HealthContractTypeName} idSelector={form.IDHealthContractType} onChange={(e) => { setForm({ ...form, "IDHealthContractType": e.IDHealthContractType, "HealthContractTypeName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                     <BasicSwitch label="Habilitado" estado={Enabled} eventChange={(e) => { setEnabled(e) }}></BasicSwitch>
                </div>
                <div className="col-md-4">
                    <InputDate notDate label="Fecha de Búsqueda" name="InitDate" value={date} setDate={(e) => { setdate(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={contract.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={contract.bean.Name} onChange={contract.handleChange} />
                            </div>
                              <div className="col-md-6">
                            <HealthContractTypeEditor render={contract.bean.HealthContractTypeName} idSelector={contract.bean.IDHealthContractType} onChange={(e) => { contract.setBean({ ...contract.bean, "IDHealthContractType": e.IDHealthContractType, "HealthContractTypeName": e.Name }) }} returnType="Object" />
                            </div>
                              <div className="col-md-6">
                               <AccountEditor label="Tercero" idAccount={contract.bean.IDAccount} onChange={(e) => { contract.setBean({ ...contract.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                             <div className="col-md-4">
                    <InputDate notDate label="Fecha Inicio" name="InitDate" value={contract.bean.InitDate} setDate={(e) => { contract.setBean({ ...contract.bean, "InitDate": e }) }} />
                </div>
                 <div className="col-md-4">
                    <InputDate notDate label="Fecha Hasta" name="UptoDate" value={contract.bean.UptoDate} setDate={(e) => { contract.setBean({ ...contract.bean, "UptoDate": e }) }} />
                </div>
                <div className="col-md-6">
                     <BasicSwitch label="Habilitado" estado={contract.bean.Enabled} eventChange={(e) => { contract.setBean({ ...contract.bean, "Enabled": e }) }}></BasicSwitch>
                </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={contract.bean.Code} onChange={contract.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Objeto</label>
                                <textarea name="Description" className="form-control" value={contract.bean.Description} onChange={contract.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {contract.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}